export const ALL_SUBCATEGORY = 'all';
